import Grid from '@mui/material/Grid';
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from '@mui/styles';
import clsx from "clsx";
import { DialogTitle, Box } from "@mui/material";
import { renderSplittedRow } from "../../../freya/scanBadge/hooks/utils/utils";

type Props = {
  title: string;
  subtitle?: string;
  handleClose: () => void;
  className?: string;
  alignCenter?: boolean;
  hideCloseIcon?: boolean;
};

const useStyles = makeStyles({
  icon: {
    cursor: "pointer",
    marginRight: 20
  },
  title: {
    fontSize: 24,
    fontWeight: 600,
    ["@media (max-width:768px)"]: {
      fontSize: 19,
      wordBreak: 'break-word',
      width: '50%'
    }
  },
  descFirstPart: {
    display: 'inline',
    fontWeight: 500,
    fontSize: '15px',
    paddingRight: '5px'
  },
  descSecondPart: {
    display: 'inline',
    fontSize: '15px'
  },
  subtitle: {
    textAlign: 'center',
    margin: '0 20px'
  }
});

export const DialogTitleWithCloseIcon = ({ title, subtitle, handleClose, className, alignCenter, hideCloseIcon }: Props) => {
  const classes = useStyles();

  return (
    <Grid container direction="column" justifyContent="center" alignItems="center">
      <Grid container direction="row" justifyContent={alignCenter ? "center" : "space-between"} alignItems="center">
        <DialogTitle className={clsx(classes.title, className)} data-testid="dialog-title">{title}</DialogTitle>
        {!hideCloseIcon && <CloseIcon color="primary" data-testid="dialog-close-icon" onClick={handleClose} className={classes.icon} />}
      </Grid>
      {subtitle && <Box data-testid="dialog-subtitle" className={classes.subtitle}>{renderSplittedRow(subtitle, classes.descFirstPart, classes.descSecondPart)}</Box>}
    </Grid>
  );
};
